<template>
  <div class="sales-wrapper">

    <!-- Start New Customer -->
    <b-modal
      v-model="startCustomerModal"
      centered
      :title="selectedItem ? 'Müşteri Süreci Başlat' : 'Yeni Müşteri Ekle'"
      size="lg"
      hide-footer
    >
      <div class="row justify-content-center">
        <customer-new
          :edit-data="selectedItem"
        />
      </div>
    </b-modal>

    <!-- Modal -->
    <b-modal
      v-model="demoModal"
      centered
      :title="selectedItem ? 'Demo Talebi Düzenle' : 'Demo Talep Formu'"
      size="lg"
      hide-footer
    >
      <div class="row justify-content-center">
        <customer-demo-form
          :edit-data="selectedItem"
          @modal-false="closeModal"
          @refetch-data="refetchData"
        />
      </div>
    </b-modal>

    <!-- Alerts -->
    <b-alert v-if="loading" show variant="info" class="mb-3">
      Yükleniyor...
    </b-alert>

    <b-alert v-else-if="error" show variant="danger" class="mb-3">
      {{ error }}
    </b-alert>

    <!-- Liste -->
    <div v-else>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <p class="total-count">
          Toplam: <strong>{{ total }}</strong> demo talebi
        </p>

        <b-button variant="success" @click="openNew">
          <span class="text-nowrap">Demo Ekle</span>
        </b-button>
      </div>

      <b-table
        striped
        hover
        bordered
        responsive
        :items="items"
        :fields="fields"
        primary-key="id"
        show-empty
        empty-text="Kayıt bulunamadı"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(status)="row">
        <!-- Developer için select -->
        <b-form-select 
          v-if="isDeveloper"
          size="sm" 
          :options="statusOptions" 
          v-model="row.item.status" 
          @change="updateStatus(row.item)"
        />
        <!-- Sale Team için badge -->
        <b-badge 
          v-else-if="isSaleTeam"
          pill 
          :variant="getStatusVariant(row.item.status)"
          class="text-capitalize"
        > 
          {{ getStatusText(row.item.status) }}
        </b-badge>
      </template>


        <!-- Düzenle butonu -->
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            @click="openEdit(row.item)"
          >
            Düzenle
          </b-button>
          <b-button size="sm" class="ml-1" @click="row.toggleDetails">
            Detay Gör
          </b-button>
          <b-button
            v-if="isDeveloper"
            size="sm"
            class="ml-1"
            variant="success"
            @click="startCustomer(row.item)"
          >
            Süreci Başlat
          </b-button>
        </template>

        <!-- Detay satırı -->
        <template #row-details="row">
          <b-card>
            <ul class="mb-0">
              <li><strong>Short link:</strong> {{ row.item.short_link_domain }}</li>
              <li><strong>Cari:</strong> {{ row.item.cari_name }}</li>
              <li><strong>Admin E-posta:</strong> {{ row.item.admin_email }}</li>
              <li><strong>Telefon:</strong> {{ row.item.phone }}</li>
              <li><strong>Altyapı:</strong> {{ row.item.altyapi }}</li>
              <li><strong>Muhasebe E-posta:</strong> {{ row.item.accounting_email }}</li>
              <li><strong>Paket:</strong> {{ row.item.package }}</li>
              <li><strong>Not:</strong> {{ row.item.note }}</li>
              <li><strong>Oluşturulma:</strong> {{ row.item.created_at }}</li>
            </ul>
          </b-card>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { BTable, BAlert, BButton, BCard, BFormSelect, BBadge } from "bootstrap-vue";
import CustomerDemoForm from "@/components/manage/CustomerDemoForm.vue";
import CustomerNew from "@/components/manage/CustomerNew.vue";

export default {
  name: "DemoRequestList",
  components: { BTable, BAlert, BButton, BCard, BFormSelect, CustomerDemoForm, BBadge, CustomerNew },
  data() {
    return {
      items: [],
      total: 0,
      loading: false,
      error: null,
      sortBy: "id",
      isSortDirDesc: true,
      demoModal: false,
      startCustomerModal: false,
      selectedItem: null,
      fields: [
        { key: "id", label: "ID", sortable: true },
        { key: "company_name", label: "Firma", sortable: true },
        { key: "domain", label: "Domain", sortable: true },
        { key: "created_at", label: "Oluşturulma", sortable: true },
        { key: "status", label: "Durum" },
        { key: "actions", label: "İşlemler" },
      ],
      statusOptions: [
        { value: "pending", text: "Beklemede" },
        { value: "processing", text: "İşleniyor" },
        { value: "completed", text: "Tamamlandı" },
      ],
    };
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    // Status variant belirleme
    getStatusVariant(status) {
      const variants = {
        'pending': 'light-warning',
        'processing': 'light-info', 
        'completed': 'light-success'
      }
      return variants[status] || 'light-secondary'
    },
    getStatusText(status) {
      const texts = {
        'pending': 'Beklemede',
        'processing': 'İşleniyor',
        'completed': 'Tamamlandı'
      }
      return texts[status] || status
    },
    async updateStatus(item) {
      try {
        const res = await this.$http.post(`/manage/customer/demo/update-status`, {
          id: item.id,
          status: item.status,
        });
        if (!res.data.success) {
          this.$bvToast.toast(res.data.error || "Durum güncellenemedi", {
            title: "Hata",
            variant: "danger",
            solid: true,
          });
        } else {
          this.$bvToast.toast("Durum başarıyla güncellendi", {
            title: "Başarılı",
            variant: "success",
            solid: true,
          });
        }
      } catch (err) {
        this.$bvToast.toast("Sunucu hatası: " + err, {
          title: "Hata",
          variant: "danger",
          solid: true,
        });
      }
    },
    async fetchItems() {
      this.loading = true;
      this.error = null;
      try {
        const res = await this.$http.get("/manage/customer/demo");
        if (res.data.success) {
          this.items = res.data.data;
          this.total = res.data.total;
        } else {
          this.error = res.data.error || "Bir hata oluştu.";
        }
      } catch (err) {
        this.error = "Sunucu hatası: " + err;
      } finally {
        this.loading = false;
      }
    },
    refetchData() {
      this.fetchItems();
      this.closeModal();
    },
    openNew() {
      this.selectedItem = null;
      this.demoModal = true;
    },
    startCustomer(item) {
      this.selectedItem = { ...item }; // seçili kaydı form’a gönder
      this.startCustomerModal = true;
    },  
    openEdit(item) {
      this.selectedItem = { ...item }; // seçili kaydı form’a gönder
      this.demoModal = true;
    },
    closeModal() {
      this.demoModal = false;
      this.selectedItem = null;
    },
  },
};
</script>

<style scoped lang="scss">
.sales-wrapper {
  padding: 1rem;

  .total-count {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
}
</style>
